import { OrderProduct } from '../OrderProduct';

import { OrderProductsByDeliveryWindow } from './OrderProductsGroup/DeliveryWindowGroup/OrderProductsByDeliveryWindow';
import { OrderProductsByStockType } from './OrderProductsGroup/StockTypeGroup/OrderProductsByStockType';
import { useOrderProductsContext } from './OrderProductsContext';

export const OrderProductList = () => {
  const { sortByByDeliveryWindow, sortedProducts, sortByStockType } = useOrderProductsContext();

  if (sortByByDeliveryWindow) {
    return <OrderProductsByDeliveryWindow />;
  }

  if (sortByStockType) {
    return <OrderProductsByStockType />;
  }

  return (
    <div className="space-y-5 pt-5">
      {sortedProducts.map(product => (
        <OrderProduct key={product.product} productInfo={product} />
      ))}
    </div>
  );
};
